import React, { Suspense, useEffect, useState } from 'react';
import Header from '../Header/header';
import { CommonUtilities } from '../../commonUtils';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';



export default function SearchFilter(autoOpen: any) {

    return (
        <div className='ws-12'>
            <div className="plxl prxl">
                <div className="ptxl mtl ptl">
                    <div className="ws-9">
                        <span className="ws-12 text-bold text-xl">Search / Filter</span>
                        <span className="ws-12 ptl text-bold text-m turquoise">Advance Search</span>
                    </div>
                </div>
                <div className="ws-12 ptxl">
                    <div className="mtl ws-12 pull-left">
                        <div className="ws-10 pr">
                            <button className="btn white pLarge bg-level14 m0 ws-2"> Search</button>
                            <input type="text" className="pLarge ws-10 m0 heightReset" placeholder="Type to search" value="" />
                        </div>
                        <div className="ws-2">
                            <button className="btn white bg-level14 pLarge m0 ws-12">Advanced Search </button>
                        </div>
                        <div className="ws-12 forceSingleLine"></div>
                    </div>
                </div>

                <div className="ws-12 ptxl">
                    <div className="ptxl mtl ptl">
                        <div className="ws-9">
                            <span className="ws-12 ptl text-bold text-m turquoise">Advance Search Slider</span>
                        </div>
                    </div>

                    <div className="mtl ws-12 pull-left">
                        

                        <div className="box ws-6 pull-right full-height-vh">
                            <div className="box-header-main">
                                <h2 className="pull-left"> Search Creators</h2>
                            </div>


                            <div className="box-content">

                                
                                <div className="form-format ws-6">
                                    <label>ISRC</label>
                                    <input name="KontactCode" type="text" placeholder="Code" className="ws-11" />
                                </div>

                                
                                <div className="form-format ws-6">
                                    <label>Master code</label>
                                    <input name="KontactCode" type="text" placeholder="Code" className="ws-11" />
                                </div>

                                
                                <div className="form-format ws-6">
                                    <label>Status</label>
                                    <input name="KontactCode" type="text" placeholder="Code" className="ws-11" />
                                </div>

                                
                                <div className="form-format ws-6">
                                    <label>Extended Status</label>
                                    <select className='ws-11'>
                                        <option value="">Choose Extended Status</option>
                                        <option value="0" label="AUTOCREATED">AUTOCREATED</option>
                                        <option value="1" label="OFFICIAL">OFFICIAL</option>
                                    </select>
                                </div>


                            </div>

                            <div className="box-footer">
                                <button className="icon-btn delete pull-right">
                                    <i className="icon-close"></i>
                                    Close
                                </button>
                                <button className="icon-btn edit pull-right">
                                    <i className="icon-search"></i>
                                    Search
                                </button>
                            </div>
                        </div>




                    </div>
                </div>



                <div className="ws-12 ptxl">
                    <div className="ptxl mtl ptl">
                        <div className="ws-9">
                            <span className="ws-12 ptl text-bold text-m turquoise">Front End Filter</span>
                        </div>
                    </div>

                    <div className="mtl ws-12 pull-left">
                        

                        <div className="box ws-6 pull-right full-height-vh">
                            <div className="box-header-main">
                                <h2 className="pull-left"> Search Creators</h2>
                            </div>


                            <div className="box-content">




                            </div>

                            <div className="box-footer">
                                <button className="icon-btn delete pull-right">
                                    <i className="icon-close"></i>
                                    Close
                                </button>
                                <button className="icon-btn edit pull-right">
                                    <i className="icon-search"></i>
                                    Search
                                </button>
                            </div>
                        </div>




                    </div>
                </div>


            </div>
        </div>
    )
}